import { Routes, RouterModule } from "@angular/router";

// import { AlertMaintComponent } from './AlertMaint/alertmaint.component';
import { EventsEventScanningResultsComponent } from "./events-event-scanning-results/events-event-scanning-results.component";
import { EventsAssignStudentsComponent } from "./events-assign-students/events-assign-students.component";
import { EditStudentGroupsComponent } from "./edit-student-groups/edit-student-groups.component";
import { EventsScheduledEventsComponent } from "./events-scheduled-events/events-scheduled-events.component";
import { DefineEventsComponent } from "./define-events/define-events.component";
import { AddToGroupComponent } from "./add-to-group/add-to-group.component";
import { AuthguardService } from "../master/services";

export const GroupsRoutes: Routes = [
	// {path:'event', data:{title:'Events'},component:EventsComponent},
	// {path:'', redirectTo:'/group/studentgroups', pathMatch:'full'},

	{
		path: "studentgroups",
		data: { title: "Student Groups" },
		component: EditStudentGroupsComponent,
		canActivate: [AuthguardService],
	},

	{
		path: "event/defineevents",
		data: { title: "Define Events" },
		component: DefineEventsComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "event/scheduledevents",
		data: { title: "Scheduled Events" },
		component: EventsScheduledEventsComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "event/assignstudents",
		data: { title: "Assign Students" },
		component: EventsAssignStudentsComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "event/eventscanningresults",
		data: { title: "Event Scanning Results" },
		component: EventsEventScanningResultsComponent,
		canActivate: [AuthguardService],
	},

	{
		path: "addtogroup",
		data: { title: "Add to Group" },
		component: AddToGroupComponent,
		canActivate: [AuthguardService],
	},
];
